/**
 * @fileoverview POST handler for the "/engagement/campaigns/conversion_correlation_data/:campaign_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { engagementCampaignsConversionCorrelationDataCampaignIdCacheKeys } from "./constants";
import type {
  GetEngagementCampaignsConversionCorrelationDataCampaignIdProps,
  EngagementCampaignsConversionCorrelationDataCampaignIdResult,
} from "./types";

export const getEngagementCampaignsConversionCorrelationDataCampaignId = reactQueryMutationAdapter(
  engagementCampaignsConversionCorrelationDataCampaignIdCacheKeys,
  (
    props: GetEngagementCampaignsConversionCorrelationDataCampaignIdProps
  ): Promise<EngagementCampaignsConversionCorrelationDataCampaignIdResult> => {
    return fetch(`/engagement/campaigns/conversion_correlation_data/${props.campaignId}`, "GET", props, undefined, {
      // don't display a modal on fetch errors
      propagateFetchRequestError: false,
    });
  }
);
